export default __webpack_public_path__ + "images/941abf5543a090cf903f8b598c9b1de1.png";